module.exports = __webpack_public_path__ + "img/invalid.8fd50657.png";